// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { myAccountViewStyles } from "@turnerBlueprint/Overrides/Widgets/MyAccount/MyAccountView";
import { DivWrapper } from "@turnerBlueprint/XDL/constants";
import { fontConfig } from "@turnerBlueprint/XDL/PreStyle/typography";
import { xScreen } from "@turnerBlueprint/XDL/Utilities";
import { css } from "styled-components";

myAccountViewStyles.quickLinksSection = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 24px;
        ${xScreen("lte", "md")} {
            order: 1;
            flex-direction: row;
            gap: 20px;
        }
        ${xScreen("lt", "sm")} {
            flex-direction: column;
        }
    `,
};

myAccountViewStyles.actionSection = {
    wrapper: {
        css: css`
            margin-top: 20px;
        `,
    },

    signOutButton: {
        css: css`
            display: flex;
            margin-bottom: 8px;
        `,
        typographyProps: {
            size: 14,
            lineHeight: "22px",
            color: "common.ui4",
            weight: fontConfig.weight.bold,
        },
    },
};

myAccountViewStyles.linksBox = {
    container: {
        css: css`
            width: 100%;
            ${xScreen("lte", "md")} {
                width: 50%;
            }
            ${xScreen("lt", "sm")} {
                width: 100%;
            }
        `,
    },
};

myAccountViewStyles.extraCardWraaper = {
    css: css`
        width: 100%;
        & > div {
            display: flex;
            flex-direction: column;
            gap: 24px;
        }
        ${xScreen("lte", "md")} {
            width: 50%;
        }
        ${xScreen("lt", "sm")} {
            width: 100%;
        }
    `,
};

myAccountViewStyles.mainSectionGridItem = { width: [12, 12, 12, 9, 9] };

myAccountViewStyles.accountMessagesGridItem = {
    width: 12,
};

myAccountViewStyles.container = {
    css: css`
        display: grid;
        grid-template-columns: 297px minmax(0, 1fr);
        gap: 42px;
        width: 100%;
        div:has(> ${DivWrapper}:empty) {
            display: none;
        }
        ${xScreen("lte", "md")} {
            grid-template-columns: minmax(0, 1fr);
            gap: 40px;
        }
    `,
};

myAccountViewStyles.mainContainer = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 20px;
    `,
};

myAccountViewStyles.welcomeAndMessagesSection = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 12px;
    `,
};

myAccountViewStyles.dashboardButton = {
    typographyProps: {
        size: 14,
        lineHeight: "22px",
        css: css`
            margin-bottom: 20px;
        `,
    },
};
